import { faStickyNote, faTrash, faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, OverlayTrigger, Popover } from 'react-bootstrap';
import { CDBurnerFilter } from 'reducers/burnerFiltersReducer';
import React, { Dispatch, SetStateAction } from 'react';

type CDBurnerFilterRowProps = {
  filter: CDBurnerFilter;
  showModal: (filter: CDBurnerFilter | undefined) => void;
  setDeletingFilter: Dispatch<SetStateAction<CDBurnerFilter | undefined>>;
};

const CDBurnerFilterRow = ({ filter, showModal, setDeletingFilter }: CDBurnerFilterRowProps) => {
  const notesOverlay = notes => (
    <Popover id="notesOverlay">
      <div style={{ whiteSpace: 'pre-wrap' }}>{notes}</div>
    </Popover>
  );

  return (
    <tr>
      <td>{filter.filterTag}</td>
      <td>{filter.filterCondition}</td>
      <td>{filter.filterValue}</td>
      <td>{filter.enabled ? <Badge variant="success">True</Badge> : <Badge variant="danger">False</Badge>}</td>
      <td>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={notesOverlay(filter.notes)}>
          <FontAwesomeIcon
            visibility={filter.notes.length > 0 ? 'visible' : 'hidden'}
            icon={faStickyNote}
            className="clickable-icon clickable-icon-notes"
            onClick={() => showModal(filter)}
          />
        </OverlayTrigger>
        <FontAwesomeIcon className="clickable-icon" icon={faWrench} onClick={() => showModal(filter)} />
        <FontAwesomeIcon
          className="clickable-icon printer-table-actions"
          icon={faTrash}
          onClick={() => setDeletingFilter(filter)}
        />
      </td>
    </tr>
  );
};

export default CDBurnerFilterRow;
